module.exports = __webpack_public_path__ + "media/images/Heart_Inactive-e5fe7025.png";